const elementId = {
    PartnerForm: document.getElementById("partner-form"),
    Field: {
        FirstName: document.getElementById("partner-first-name"),
        LastName: document.getElementById("partner-last-name"),
        Email: document.getElementById("partner-email"),
        BusinessType: document.getElementById("partner-business-type"),
        BusinessTypeOther: document.getElementById("partner-business-type-other"),
    },
    FormRequestPanel: document.getElementById("form-request-panel"),
    FormFeedbackPanel: document.getElementById("form-feedback-panel"),
    FormFeedbackMessage: document.getElementById("form-feedback-message"),
    PartnerFormSubmitBtn: document.getElementById("partner-form-submit-btn"),
    PartnerFormSubmitLoading: document.getElementById("partner-form-submit-loading"),
    RecaptchaBtn: document.querySelector(".g-recaptcha")
};

document.addEventListener("DOMContentLoaded", function () {
    const businessTypeOptions = elementId.Field.BusinessType.options;

    elementId.Field.BusinessType.addEventListener("change", function (e) {
        if (e.target.value === businessTypeOptions[businessTypeOptions.length - 1].value) {
            elementId.Field.BusinessTypeOther.classList.remove("hidden");
            elementId.Field.BusinessTypeOther.focus();
            elementId.Field.BusinessTypeOther.setAttribute("required", true);
            return;
        }

        elementId.Field.BusinessTypeOther.classList.add("hidden");
        elementId.Field.BusinessTypeOther.removeAttribute("required");
    });

    elementId.PartnerForm.addEventListener("submit", (e) => e.preventDefault());
});

function submitPartnerForm(token) {
    elementId.RecaptchaBtn.classList.add("hidden");
    elementId.PartnerFormSubmitLoading.classList.remove("hidden");

    const formModel = {
        FirstName: elementId.Field.FirstName.value,
        LastName: elementId.Field.LastName.value,
        Email: elementId.Field.Email.value,
        BusinessType: elementId.Field.BusinessType.value,
        BusinessTypeOther: elementId.Field.BusinessTypeOther.value,
        RecaptchaToken: token
    }

    fetch('/resources/partners/partners-form-submission', {
        method: 'POST',
        body: JSON.stringify(formModel),
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(resp => resp.json())
        .then(data => {
            if (data.Successful) {
                elementId.FormRequestPanel.classList.add('hidden');
            } else {
                elementId.RecaptchaBtn.classList.remove("hidden");
                elementId.PartnerFormSubmitLoading.classList.add("hidden");
            }

            elementId.FormFeedbackPanel.classList.remove('hidden');
            elementId.FormFeedbackMessage.innerHTML = data.Data;
        });
}

function triggerReCaptchaValidation(token) {
    const valid = elementId.PartnerForm.checkValidity();
    elementId.PartnerForm.classList.add('validated');

    if (valid) {
        submitPartnerForm(token);
    } else {
        elementId.PartnerForm.reportValidity();
        grecaptcha.reset();
    }
}